import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-piechart15',
  templateUrl: './piechart15.component.html',
  styles: [
    `
    .highcharts-container {
    height:343px;
    }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Piechart15Component {
  @ViewChild('chartContainer') chartContainer!: ElementRef;
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  private subscriptions: Subscription = new Subscription();


  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private cdr: ChangeDetectorRef,
    private _configService: SnapshotService,
    private significanceService: SignificanceService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      
      this.updateComponent(); // Manually trigger change detection
    }
  }

  updateComponent() {
    //  this.cdr.detectChanges();
    this.updateSig();
  }

  jsondata: any;
  seriescolor: any;
  samplesizeconstant: any;
  chartproperties: any;
  seriesgradientcolor: any;
  chartimagepath: any
  @Input() id: any;
  @Input() height: any;
  @Input() data: any;
  significanceValue: any = "None";
  DefaultConfidenceLevel: any = "";

  ngOnInit(): void {
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe(value => {
        this.DefaultConfidenceLevel = value;
        this.updateSig();
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe(value => {
        this.significanceValue = value;
        this.updateSig();
      }));

  }

  // ngAfterViewInit(){
  //    
  //   this.plotChart('chart-container1', this.jsondata['data'], this.chartproperties);

  // }
  customization(): Observable<any[]> {
    return this.piechartservice.PieChart1to10customizationList();
  }
  seriesdata: any;
  cov: any;
  significance: any;
  samplesize: any;
  label: any;
  datalength: number = 10;
  heightAsperResolution = '48%';

  chartMainData: any = [];
  updateSig() {

    const screenHeight = window.innerHeight; // Get the screen width
    

    if (screenHeight <= 610) { //for 150% -> 593
      this.heightAsperResolution='350px';
    } else if (screenHeight <= 800) { //for 125% -> 738

      this.heightAsperResolution='450px';
    } else if (screenHeight <= 1200) { //for 100%
      this.heightAsperResolution='450px';

    }


    this.subscriptions.add(
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        ;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartimagepath = this.piechartservice.chartimagepath;
        let docEle = document.getElementById('chart-container' + this.id)
        if (docEle != null) {
          docEle.innerHTML = '';
        }
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);

      }));
  }
  preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];
    data.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.metricName,
            "Category Name": lev1.submetricName,
            "Rounded Value": dataArr.CalculationType === "share" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex":(dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    })
  }

  preparechartdata(data: any, islowsample: boolean, isgradient: boolean, isdarktheme: boolean) {
    let seriesdata: any[] = [];
    let d: any = {};
    let cov: any = [];
    let significance: any = [];
    let samplesize: any = [];
    let label: any = [];
    let i = 0;
    let innerSize = this.height != "100%" ?(data.length>1?125/data.length:80): 200/data.length;
    let size = this.height != "100%" ?(data.length>1? 225/data.length:180): 400/data.length;
    let maxinnerSize=this.height != "100%" ? 123.5 : 200;
    let maxsize= this.height != "100%" ? 125 : 200;
    data.forEach((dat: any) => {
      if (i < this.datalength) {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        d.innerSize = innerSize;
        d.size = size;
        d.animation = this.piechartservice.allowAnimation;
        let value = isNaN(parseFloat(dat['Rounded Value'])) || parseFloat(dat['Rounded Value']) == null ? null : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue = value
        let m = [
          {
            name: dat['Series Name'],
            y: (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
            indexValue:(Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
            actualIndexValue:dat['ActualIndexValue'],
            y1: this._configService.isIndexSelected ? finalvalue : (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
            legendkeycolor: this.seriescolor[i],
            actualcolor: this.seriescolor[i],
            color: !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++],
            cov: dat['Change value vs PY'],
            significance: dat['Significance'],
            significance2: dat['Significance2'],
            samplesize: dat['Sample size'],
            tooltip: "",
            isPercentage: dat["isPercentage"],
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dat["Significance_Value"]
          },
          {
            name: 'other',
            y: 100 - (value == null ? 0 : Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
            color: !isdarktheme ? '#eeebed' : '#7f7f7f',
            legendkeycolor: !isdarktheme ? '#eeebed' : '#7f7f7f',
          },
        ];
        d.data = m;
        seriesdata.push(d);
        d = {};
        innerSize += this.height != "100%" ? maxinnerSize/data.length: maxinnerSize/data.length;
        size += this.height != "100%" ? maxsize/data.length : maxsize/data.length;
        // this.datalength++;
      }
    });
    this.cov = cov;
    this.significance = significance;
    this.label = label;
    this.samplesize = samplesize;
    this.seriesdata = seriesdata;
  }

  chart: any;
  plotChart(containerId: any, jsondata: any, chartproperties: any) {
    localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    let height = this.height;
    let samplesizeconstant = this.samplesizeconstant;
    let chartimagepath = this.chartimagepath;
    this.preparemainChartData(this.data);
    this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor, chartproperties.darkTheme);


    const configService = this._configService;

    const containerEl = document.getElementById(containerId);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      chart: {
        type: 'pie',
        // marginBottom:50,
        // marginTop:50,
        backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
        style: {
          fontFamily: this.piechartservice.fontFamily,
          width: '100%',
          // width:300,
          // height:"100%"
        },
        events: {
          // render: function () {
          //   const chart = this as any;

          //   // Check if the image and circle already exist, and return without rendering if they do
          //   if (chart.groupImage && chart.dottedBorder) {
          //     // Update the position of existing elements if the chart position changes
          //     if (chart.groupImage.attr('x') !== chart.plotLeft + chart.plotWidth / 2 - 50 / 2 ||
          //         chart.groupImage.attr('y') !== chart.plotTop + chart.plotHeight / 2 - 50 / 2) {
          //       chart.groupImage.attr({
          //         x: chart.plotLeft + chart.plotWidth / 2 - 20 / 2,
          //         y: chart.plotTop + chart.plotHeight / 2 - 20 / 2,
          //       });
          //     }

          //     if (chart.dottedBorder.attr('cx') !== chart.plotLeft + (chart.plotWidth / 2.05) + 7 ||
          //         chart.dottedBorder.attr('cy') !== chart.plotTop + (chart.plotHeight / 2) + 0) {
          //       chart.dottedBorder.attr({
          //         cx: chart.plotLeft + (chart.plotWidth / 2),
          //         cy: chart.plotTop + (chart.plotHeight / 2) + 0,
          //       });
          //     }

          //     return;
          //   }

          //   let imageUrl = chartimagepath;

          //   // Render the image if it doesn't exist
          //   if (!chart.groupImage) {
          //     chart.groupImage = chart.renderer
          //       .image(
          //         imageUrl,
          //         chart.plotLeft + chart.plotWidth / 2 - 20 / 2, // X position calculation
          //         chart.plotTop + chart.plotHeight / 2 - 20 / 2, // Y position calculation
          //         20,
          //         20
          //       )
          //       .attr({
          //         display: chartproperties.image ? 'block' : 'none',
          //       })
          //       .add();
          //   }

          //   // Render the dotted border if it doesn't exist
          //   if (!chart.dottedBorder) {
          //     let borderWidth = 1; // Border width
          //     let borderColor = chartproperties.darkTheme ? 'white' : '#333'; // Border color
          //     let centerX2 = chart.plotLeft + (chart.plotWidth / 2) ; // X position of the center
          //     let centerY2 = chart.plotTop + (chart.plotHeight / 2) + 0; // Y position of the center
          //     // let circleRadius = Math.min(chart.plotWidth, chart.plotHeight) / 7.5; // Radius of the circle
          //     let circleRadius="1.3em"
          //     chart.dottedBorder = chart.renderer
          //       .circle(centerX2, centerY2, circleRadius)
          //       .attr({
          //         fill: 'none', // Transparent fill
          //         'stroke-width': borderWidth,
          //         stroke: borderColor,
          //         dashstyle: 'Dash',
          //         display: chartproperties.innerBorder ? 'block' : 'none',
          //       })
          //       .add();
          //   }

          //   // Update the position of the elements when the chart is redrawn
          //   // chart.addEvent('redraw', function () {
          //   //   chart.groupImage.attr({
          //   //     x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
          //   //     y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
          //   //   });

          //   //   chart.dottedBorder.attr({
          //   //     cx: chart.plotLeft + (chart.plotWidth / 2.05) + 7,
          //   //     cy: chart.plotTop + (chart.plotHeight / 2) + 0,
          //   //   });
          //   // });
          // },
          load: function () {
            const chart = this as any;
            window.addEventListener('resize', function () {
              chart.reflow();
            });
          }

        }
      },
      title: {
        text: "",
        align: chartproperties.chartTitlePosition,
        verticalAlign: 'top',
        style: {
          color: chartproperties.darkTheme ? 'white' : 'black',
          fontSize: "2rem"
        },
      },
      legend: {
        navigation: {
          itemMarginLeft: 10,
          activeColor: '#7f7f7f',
          animation: true,
          arrowSize: 10,
          inactiveColor: '#ccc',
          style: {
            fontSize: '0.7em',
            color: chartproperties.darkTheme ? 'white' : '#333',
          }
        },
        // y:chartproperties.legendPosition == 'bottom'?0:4,
        maxHeight: chartproperties.legendPosition == 'bottom' ? 45 : 300,
        layout:
          chartproperties.legendPosition != 'bottom'
            ? 'vertical'
            : 'horizontal',
        x: this.height == "100%" ? 50: -20,
        // width: height=='100%'?100:'100%',
        // itemWidth: 400,
        align: chartproperties.legendPosition,
        verticalAlign:
          chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
        symbolWidth: 0,  // Set to a valid non-negative value
        symbolHeight: 0, // Set to a valid non-negative value
        //symbolWidth: -1,
        //symbolHeight: -1,
        useHTML: true,
        itemMarginTop: 0,    // Adjust this value to reduce the top margin
        // itemMarginLeft:-50,
        itemMarginBottom: -5,
        itemStyle: {
          fontWeight: "normal",
          fontSize: this.height != "100%" ? '0.8em' : '1em',
          cursor: 'pointer'
        },
        labelFormatter: function (): any {
          let point = this as any;
          let textcolor = chartproperties.darkTheme ? 'white' : 'black';
          if (point.color != "#eeebed" && point.color != "#7f7f7f") {
            return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
              + '<div style="display:flex;width:10px;height:10px;background-color:' + point.legendkeycolor + ';border-radius:50%"></div>'
              + '<div style="width:' + (height != "100%" ? '120px' : '19.5rem') + ';height:20px;padding-left:10px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
              + '</div>';
          }
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',


        formatter: function (this: any): any {
          const pointWithMetric = this.point as {
            name?: any;
            parent?: any;
            color?: any;
            actualcolor?: any;
            y?: number;
            y1?: number;
            cov?: string;
            significance?: string;
            significance2?: string;
            samplesize?: number;
            tooltip?: any;
            Significance_Value?: any;
          };
          if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
          const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
          if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

          let isDefaultTooltip = chartproperties.toolTipStyle;
          if (isDefaultTooltip == "style1") {
            const dotColor = pointWithMetric.actualcolor;
            const commonContent =
              `<div style="border-left: 2px solid ` + dotColor + `; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
              // `<span><strong>Series Name:</strong></span>Brands<br>` +
              ` ${pointWithMetric.name} : ` +
              `${pointWithMetric.tooltip}`;
            return commonContent + '</div>';
          }
          else if (chartproperties.datalabelStyle === 'sigChange') {

          }
          else {
            const dotColor = pointWithMetric.actualcolor; // Get the series color

            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
              `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

            return content + '</div>';

          }



        },
      },
      plotOptions: {
        series: {
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false
            },
            inactive: {
              enabled: false
            },
            select: {
              enabled: false
            }
          }
        },
        pie: {
          innerSize: '100%',
          showInLegend: chartproperties.showLegend,
          borderWidth: this.height == "100%" ? 2 : 0,
          borderColor: 'white',
          slicedOffset: 10,
          shadow: chartproperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels: {
            allowOverlap: true,
            align: function (this: Highcharts.TooltipFormatterContextObject): string {
              // Align labels based on the position of the data point
              return (this.point.index % 2 === 0) ? 'left' : 'right';
            },
            //alignTo: 'connectors',
            //y: 0,
            style: {
              textOutline: 'none',
              fontSize: chartproperties.dataLabelSize,
              fontWeight: "normal"
            },
            //padding:10,
            crop: false,
            enabled: chartproperties.showDataLabel,
            connectorWidth: chartproperties.connector ? 1 : -1,
            connectorColor: null,
            //color: chartproperties.dataLabelColor == "default" ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
            connectorPadding: 0,
            distance: chartproperties.connector ? 20 : 50,
            connectorShape: 'crookedLine',
            crookDistance: '70%',
            softConnector: false,
            useHtml: true,
            formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
              const pointWithMetric = this.point as {
                name?: any;
                parent?: any;
                color?: any;
                y?: number;
                y1?: number;
                cov?: string;
                significance?: string;
                samplesize?: number;
                significance2?: any;
                tooltip?: any;
                isPercentage?: any;
                Sig_LowerLimt?: any;
                Sig_UpperLimt?: any;
                Significance_Value?: any;
                indexValue?:any;
                actualIndexValue?:any;
              };
              if (this.point.color !== '#eeebed' && this.color != '#7f7f7f') {

                chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                ;
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                if (chartproperties.datalabelStyle == 'datalabel') {
                  ;
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                  text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                //new
                if (chartproperties.datalabelStyle === "index") {

                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                  text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                  // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                  let text2 = pointWithMetric.actualIndexValue == null ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                  let color = configService.CheckIndexColoring(String(text2));
                  pointWithMetric.tooltip = text+"("+text2+")";
                  return (
                    '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + '</span>' +
                    '<span style="color:' + color + ';font-size:0.45rem;">'+" "+'(' + text2 + ')</span>'
                  );
                }

                if (chartproperties.datalabelStyle === 'sigChange') {
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                  let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                  if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                    let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                  else {
                    let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                    //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                    let text = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';">' + text + '</span>'
                    );

                  }

                }
                if (chartproperties.datalabelStyle === 'change') {
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                if (chartproperties.datalabelStyle === 'significance + changeVs') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>' : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' +
                    textcolor +
                    ';">' +
                    text +
                    '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = pointWithMetric.significance;
                  let s =
                    Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                  let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                  let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' +
                    textcolor +
                    ';">' +
                    text +
                    '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == 'ls') {
                  let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == "significance2") {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = pointWithMetric.significance;
                  let sig1 = pointWithMetric.significance2;
                  let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                  let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                  if (Number(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  pointWithMetric.tooltip = '<span>' + text +
                    (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  return (
                    '<span>' + text +
                    (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                }
              } else {
                return null;
              }
            },
          }

        }
      },
      series: this.seriesdata,
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      }
    } as any,
    );

  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  }

  userselectedproperties() {
    this.jsondata['data'] = this.jsondata['data'].slice(0, this.datalength);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    if (this.chart) { this.chart.destroy(); this.chart = null; }
    this.subscriptions.unsubscribe();
  }

}
